/* All the global variables, mixins goes here */
@use "sass:math";
@import '../../../static/scss/resources/default.variables.scss';
@import '../../../static/scss/resources/default.style.scss';

#myInput {
  box-sizing: border-box;
  background-position: 14px 12px;
  background-repeat: no-repeat;
  font-size: 16px;
  padding: 14px 20px 12px 45px;
  border: none;
  border-bottom: 1px solid #ddd;
}

#myInput:focus {outline: 3px solid #ddd;}

.custom-dropdown {
  position: relative;
  display: inline-block;
}

.custom-dropdown-content {
  background-color: $color-bg;
  min-width: 376px;
  overflow: auto;
  z-index: 1;
}

.custom-dropdown-content a {
  color: $dropdown-link-color;
  padding: 6px 12px 6px 16px;
  text-decoration: none;
  display: block;
  cursor:pointer;
}

.custom-dropdown-content a:hover {
  color: $black;
}

#myDropdown a:hover {background-color: $dropdown-link-hover-bg; color:$color-danger-fg !important;}

.search_icon{
  color: $white;
  cursor: pointer;
  padding-right: 8px;
}
.hidden { display:none; }

.visible { display:block; }

.menu-groups, .help-groups{
  background-color: $color-gray-light;
  padding: 6px;
  font-size: 12px;
  font-weight: 600;
}

.menu-groups .fa, .fas{
  font-weight:normal !important;
}

.help-groups .fa, .fas{
  font-weight:600 !important;
}

.pad-12{
  padding:12px;
}

.no-results{
  font-size: 14px;
  color: #697986;
  text-align: center;
}

.no-padding{
  padding:0 !important;
}

.menu-groups-a{
  display:flex !important;
  flex-direction:column;
  padding: 6px 16px;
  color: $dropdown-link-color;
}

.menu-groups-a span{
  font-size: 0.9em;
  font-weight: 100;
  color: $quick-search-span-text;
}

#myDropdown a:hover span{
  color: $color-danger-fg !important;
}

.search-icon{
  background: $loader-icon-small center center no-repeat;
  margin: auto !important;
  height: 22px !important;
  width: 130px !important;
  background-position: left !important;
  font-size: 14px;
  color: $dropdown-link-color;
  padding-left: 30px;
}

.help_loading_icon{
  height: 16px;
}
#myDropdown ul {
  list-style: none;
}

.border-right-search-icon{
  border-right: 2px solid #fff;
}

.help_submenu{
  left: 100%;
  width: 20rem;
  top:-0.4rem;
}

.help_menu{
  min-width:300px;
}

.dropdown-item-input{
  padding:4px;
}

.menu-groups-a span:focus{
  color:$color-primary-fg;
}

.dropdown-item:hover, .dropdown-item:focus span{
  color: $color-danger-fg !important;
}

.quick-search-tooltip{
  position: absolute;
  right: 10px;
  margin-top: -2.1em;
  font-size: 16px;
  cursor:pointer;
  color: $quick-search-info-icon;
}

#myDropdown .dropdown-divider{
  height: auto;
  border-top: 0;
}
